'use strict';

(function () {
  'use strict';

  angular.module('msSleep').controller('SleepScheduleCtrl', SleepScheduleCtrl);

  SleepScheduleCtrl.$inject = [
  /* injected from ui-router */
  'schedule', '$log', '$state', 'sleepScheduleSvc', 'eventTrackingSvc'];

  /* @ngInject */
  function SleepScheduleCtrl(schedule, $log, $state, sleepScheduleSvc, eventTrackingSvc) {
    var vm = this;
    vm.errorMinutes = sleepScheduleSvc.ERROR_THRESHOLD;
    vm.sleepBuffer = sleepScheduleSvc.SLEEP_BUFFER;
    vm.warningMinutes = sleepScheduleSvc.WARNING_THRESHOLD;

    vm.$onInit = function () {
      $log.debug('SleepScheduleCtrl activate ', schedule);
      vm.schedule = schedule;
      vm.schedule.inBedTime = moment(vm.schedule.inBedTime[0] + ":" + schedule.inBedTime[1], "HH:mm");
      vm.schedule.wakeUpTime = moment(vm.schedule.wakeUpTime[0] + ":" + schedule.wakeUpTime[1], "HH:mm");
      vm.minutesInBed = vm.schedule.preferredMinutesInBed;
      vm.absoluteMinimumMinutesInBed = vm.schedule.minimumMinutesAsleep + vm.sleepBuffer;
      vm.minimumMinutesInBed = Math.max(vm.absoluteMinimumMinutesInBed, vm.schedule.recommendedMinutesInBed - vm.errorMinutes);

      // if the current recommendation is somehow less than the minimum, use the minimum
      vm.recommendedMinutesInBed = Math.max(vm.minimumMinutesInBed, vm.schedule.recommendedMinutesInBed);

      // the value may have been allowed to be saved in a warning state.  
      // suppress the message until a change is attempted.   
      vm.noticeClosed = true;

      vm.maximumMinutesInBed = vm.recommendedMinutesInBed + vm.errorMinutes;

      // make validation copies.
      vm.recommendedWakeUpTime = moment(vm.schedule.wakeUpTime);
      // this seems totally backwards, but the  
      // in-bed time that was selected cannot be used for validation
      // because it may have not been the original recommended value
      vm.recommendedInBedTime = moment(vm.schedule.recommendedWakeUpTime).add(vm.minutesInBed * -1, 'minutes');
    };

    vm.displayHour = function (minutes) {
      return Math.floor(minutes / 60);
    };

    vm.displayMinute = function (minutes) {
      return minutes % 60;
    };

    vm.changeInBedTime = function (amount) {
      vm.noticeClosed = false;
      vm.schedule.inBedTime = moment(vm.schedule.inBedTime).add(amount, 'minutes');
      vm.minutesInBed -= amount;
    };

    vm.changeWakeUpTime = function (amount) {
      vm.noticeClosed = false;
      vm.schedule.wakeUpTime = moment(vm.schedule.wakeUpTime).add(amount, 'minutes');
      vm.minutesInBed += amount;
    };

    vm.isScheduleWarning = function () {
      return vm.minutesInBed >= vm.recommendedMinutesInBed + vm.warningMinutes || vm.minutesInBed <= vm.recommendedMinutesInBed - vm.warningMinutes;
    };

    vm.isScheduleError = function () {
      return vm.minutesInBed >= vm.maximumMinutesInBed || (vm.minutesInBed !== vm.absoluteMinimumMinutesInBed || vm.recommendedMinutesInBed - vm.errorMinutes === vm.absoluteMinimumMinutesInBed) && vm.minutesInBed <= vm.minimumMinutesInBed;
    };

    // this is the softest and therefore least relevant warning
    vm.showScheduleWarning = function () {
      return vm.isScheduleWarning() && !vm.showAtMinimumWarning() && !vm.isScheduleError() && !vm.noticeClosed;
    };

    // minimum warning takes priority over the schedule warning.  it warns but hard-stops at the lower threshold
    vm.showAtMinimumWarning = function () {
      return !vm.isScheduleError() && vm.minutesInBed === vm.minimumMinutesInBed && !vm.noticeClosed;
    };

    /// the error takes priority over both warnings and does not allow progress
    vm.showScheduleError = function () {
      return vm.isScheduleError() && !vm.noticeClosed;
    };

    vm.isValidInBedTimeChange = function (amount) {
      return sleepScheduleSvc.isValidInBedTimeChange(amount, vm.minutesInBed, vm.minimumMinutesInBed, vm.maximumMinutesInBed);
    };

    vm.isValidWakeUpTimeChange = function (amount) {
      return sleepScheduleSvc.isValidWakeUpTimeChange(amount, vm.minutesInBed, vm.minimumMinutesInBed, vm.maximumMinutesInBed);
    };

    vm.save = function () {
      eventTrackingSvc.fireEvent('sleepTool', 'scheduleSaved', 'edit');
      sleepScheduleSvc.saveSchedule({
        recommendedMinutesInBed: vm.recommendedMinutesInBed,
        inBedTime: vm.schedule.inBedTime.format('HH:mm:ss.SSSSSSSSS'),
        wakeUpTime: vm.schedule.wakeUpTime.format('HH:mm:ss.SSSSSSSSS')
      }).then(function () {
        return $state.go('vnext.content.sleep.main.plan');
      });
    };
  }
})();